import Vue from 'vue'

export const busBloqueoCiclo = new Vue()

export function esBloqueoCiclo (value) {
  if (!value) return false
  if (typeof value === 'string') {
    return value.indexOf('pago no se ha reflejado') !== -1
  }
  const body = value.body || value
  if (typeof body === 'string') {
    return body.indexOf('pago no se ha reflejado') !== -1
  }
  if (body.code === 'BLOQUEO_CICLO') return true
  if (body.bloquear === true) return true
  const msg = String(body.message || body.mensaje || '')
  return msg.indexOf('pago no se ha reflejado') !== -1
}

export function dispararBloqueoCiclo (value) {
  const body = (value && value.body) || value || {}
  busBloqueoCiclo.$emit('mostrar', body)
}
